export const colorSliderCSSVars = {
  sliderDirectionVar: `--fui-Slider--direction`,
  sliderProgressVar: `--fui-Slider--progress`,
  thumbColorVar: `--fui-Slider__thumb--color`,
  railColorVar: `--fui-Slider__rail--color`,
  thumbSizeVar: `--fui-Slider__thumb--size`,
  railSizeVar: `--fui-Slider__rail--size`,
};
